import { NgClass, NgStyle } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { ClassDirective, StyleDirective } from "@ngbracket/ngx-layout/extended";
import { ForgeAvatarModule, ForgeTooltipModule } from "@tylertech/forge-angular";
import { IInfoCardData } from "@tylertech/tyler-api-types";

@Component({
    selector: "card-avatar",
    templateUrl: "./cardAvatar.tmpl.html",
    imports: [
        ClassDirective,
        StyleDirective,
        ForgeAvatarModule,
        ForgeTooltipModule,
        MatIcon,
        NgClass,
        NgStyle,
    ]
})
export class CardAvatarComponent
{
    @Input() readonly item: IInfoCardData;

    get appIconUrl(): string { return `/library/tylerui/appIcon/${this.item.EmblemText}_AppIcon.png`; }

    get customAvatarForegroundColor(): string
    {
        const hexColor = this.item.AvatarColor.replace("#", "");
        // TODO - do we need a color helper class somewhere to do this kind of thing
        const r = parseInt(hexColor.substring(0, 2), 16);
        const g = parseInt(hexColor.substring(2, 2), 16);
        const b = parseInt(hexColor.substring(4, 2), 16);
        const yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq >= 128
            ? "#212121"
            : "#ffffff";
    }

    get emblemClass(): Record<string, boolean>
    {
        return {
            "red": /Returned|Rejected/.test(this.item.EmblemText),
            "green": this.item.EmblemText === "Ready to Pay",

            // TODO - why were we constructing this className from the initials? I can't find anywhere in our styles that would match this...
            // this.initialAlphaPipe.transform(this.item.EmblemText).toUpperCase(): true
        };
    }

    get emblemTooltip(): string { return this.item.EmblemTooltip || this.item.EmblemText || ""; }

    get emblemTextStyles(): Record<string, string> | undefined
    {

        if (!this.item.AvatarColor)
        {
            return undefined;
        }

        /* eslint-disable @typescript-eslint/naming-convention */
        return {
            "--forge-avatar-background-color": this.item.AvatarColor,
            "--forge-avatar-foreground-color": this.customAvatarForegroundColor,
        };
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    get hasEmblemText(): boolean { return !!this.item.EmblemText; }

    get hasPhoto(): boolean { return !!this.item.Photo?.Photo; }

    get photoUrl(): string { return this.hasPhoto ? `data:image/jpeg;base64,${this.item.Photo.Photo}` : ""; }

    get useAppIcon(): boolean { return this.item.UseAppIcon; }

    get useAvatarIcon(): boolean { return !!this.item.AvatarIcon && !!this.item.EmblemText; }
}
